import Image from 'next/image';
import styles from '../../styles/modules/career/CareerPreferences.module.scss';

const CareerPreferences = () => {
  return (
    <section className={['block', 'big', styles.preferences].join(' ')}>
      <div className="fixed">
        <h3>Преимущества работы у нас</h3>
        <div className={styles.preferencesGrid}>
          <div className={styles.preferencesGridFirst}>
            <Image
              src="/images/career/team.webp"
              className={styles.preferencesGridBackgroundImage}
              fill
              alt=""
            />
            <div className={styles.preferencesGridBackground} />
            <div className={styles.preferencesGridTitle}>Команда лучших</div>
            <div className={styles.preferencesGridDescription}>
              В нашей команде юристы, бухгалтеры, маркетологи, IT-специалисты и аналитики, а также
              профессиональные коучи и тренеры
            </div>
          </div>
          <div className={styles.preferencesGridSecond}>
            <div className={styles.preferencesGridTitle}>Финансовая свобода</div>
            <div className={styles.preferencesGridDescription}>
              Мы предлагаем возможность заработка нарастающим процентом от успешных сделок, а также
              предоставляем бонусы, включая покрытие расходов на рекламное продвижение.
            </div>
          </div>
          <div className={styles.preferencesGridThird}>
            <div className={styles.preferencesGridTitle}>Ценные знания</div>
            <div className={styles.preferencesGridDescription}>
              Благодаря инновационной системе обучения и собственной онлайн-платформе, наши
              сотрудники обладают не только высокой квалификацией, но и постоянно стремятся к
              профессиональному росту.
            </div>
          </div>
          <div className={styles.preferencesGridFourth}>
            <div className={styles.preferencesGridTitle}>Обширная база недвижимости</div>
            <div className={styles.preferencesGridDescription}>
              Наша уникальная коллекция объектов насчитывает более 10 000 реальных вариантов,
              собранных лично нами.
            </div>
          </div>
          <div className={styles.preferencesGridFifth}>
            <img src="/images/weloveyou.webp" alt="" />
            <div className={styles.preferencesGridTitle}>Компания с богатым опытом</div>
            <div className={styles.preferencesGridDescription}>
              Мы представляем собой крупное предприятие с безупречной репутацией и многолетним
              опытом, начиная с 1994 года. Наш путь простирается на протяжении более 32 лет, в
              течение которых мы постоянно растем и совершенствуемся.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerPreferences;
